var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myDialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.options.title,
            visible: _vm.options.dialogVisible,
            width: _vm.options.width,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.confirmBtn,
            center: "",
            "append-to-body": "",
            top: "20px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.options, "dialogVisible", $event)
            },
          },
        },
        [
          _vm._t("default"),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm._l(_vm.options.dialogFooter, function (item, index) {
                return [
                  _c(
                    "el-button",
                    {
                      key: index,
                      attrs: { type: item.type, disabled: _vm.disabledTrue },
                      on: {
                        click: function ($event) {
                          return _vm.confirmBtn(item.fnName)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }